'use strict'

// Messages shared by every screen that saves a user (My Account's Account Info,
// admin user-edit, admin user-create), so a failed save or a bad email reads
// the same everywhere. See also new-customer.vue, whose Register form applies
// the same email rules.

export const DUPLICATE_EMAIL_MESSAGE = 'That email address is already registered to another account. Please contact customer service if you want to use that email address.'

// What to tell the user about a refused save. `error` is what
// userService.saveOrUpdate rejects with: the server's validation error
// ({attribute: 'contact.emails', message, ...}), a single {code, message}
// error, or something with no message at all (e.g. the network is down).
export function saveErrorMessage (error, fallback) {
	if (error && error.attribute === 'contact.emails') {
		return DUPLICATE_EMAIL_MESSAGE
	}
	return (error && error.message) || fallback
}

// The same two email rules as the Register form: required, then a valid
// format. Returns what is wrong, or null when the address is fine. A blank or
// malformed email would leave the account unreachable for Forgotten Password.
export function emailProblem (email, validationService) {
	if (!email) {
		return 'Email required.'
	}
	if (!validationService.email(email)) {
		return 'Valid email required.'
	}
	return null
}



// WEBPACK FOOTER //
// ./src/common/user-save.js